import { Tab, Tabs } from "@mui/material";
import { Box } from "@mui/system";

export default function MuiTabs({ tabs, active, setActive, sx }) {
    return (
        <Box sx={{ mb: 1, backgroundColor: '#FFFF', boxShadow: 1 }}>
            <Tabs
                variant="scrollable"
                scrollButtons="auto"
                value={active}
                onChange={(_e, newValue) => setActive(newValue)}
                sx={sx}
            >
                {tabs.map((tab, i) => <Tab key={i} label={tab.label} value={tab.value} icon={tab.icon}/>)}
            </Tabs>
        </Box>
    )
}